import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Divider } from "@mantine/core";
import ProductDetails from "./ProductDetails";
import RenderSvg from "../renderSvg/RenderSvg";
import "./OrderDetails.css";
import { getDataFromLocalDb } from "../../services/dbService";

interface OrderDetailProps {
  title?: string;
  orderDetails: Record<string, any>[];
  skuCodeSortOrder: string[];
}

const OrderDetails = ({ title, orderDetails, skuCodeSortOrder }: OrderDetailProps) => {
  const [products, setProducts] = useState<Record<string, any>>({});

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const dbResult = await getDataFromLocalDb("Product");
        setProducts(dbResult?.data?.[0]?.data ?? {});
      } catch (error) {
        console.error("Failed to fetch product data", error);
      }
    };

    fetchProducts();
  }, []);

  const sortedOrderDetails = [...(orderDetails ?? [])].sort((a, b) => {
    const indexA = skuCodeSortOrder.indexOf(a.skuCode);
    const indexB = skuCodeSortOrder.indexOf(b.skuCode);
    return indexA - indexB;
  });

  return (
    <div className="order_details_container">
      <div className="sub_header">
        <div style={{ display: "flex" }}>
          <div className="confirmed_order_icon">
            <RenderSvg name="orderConfirmedIcon" />
          </div>
          <Typography sx={{ fontWeight: 500, fontSize: "16px !important", color: "#227C9D" }}>
            {title || "Order Details"}
          </Typography>
        </div>
      </div>

      <Divider sx={{ height: "14px" }} color="#f1f1f1" />

      <div className="product_details_list">
        {sortedOrderDetails?.map((product, index) => (
          <ProductDetails
            key={product?.skuCode || index}
            product={product}
            otherUnitName={products[product?.batchCode]?.otherUnitName}
          />
        ))}
      </div>
    </div>
  );
};

export default OrderDetails;
